<template>
    <div class="container">
        <modal v-if="showFirstLoginSurveyModal" @close="logoutUser">
            <first-login-survey @close="closeFirstLoginSurveyModal"></first-login-survey>
        </modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { logoutUser } from './../../main';
import Modal from './../modals/_modal.vue';
import FirstLoginSurvey from './../modals/main-survey/survey.vue';

export default {
    components: {
        Modal,
        FirstLoginSurvey,
    },
    computed: {
        ...mapState(['isUserLogged']),
        ...mapGetters(['accountTypeIsPro']),
        showFirstLoginSurveyModal() {
            return (
                this.$store.state.survey.survey.showFirstLoginSurveyModal && this.isUserLogged && !this.accountTypeIsPro
            );
        },
    },
    methods: {
        closeFirstLoginSurveyModal() {
            this.$store.commit('STATE_SURVEY', {
                activeStepper: 1,
                showFirstLoginSurveyModal: false,
            });
        },
        logoutUser,
    },
};
</script>



// WEBPACK FOOTER //
// dashboard.vue?86b113ea